<template>
  <div>
    <div
      class="d-flex justify-start border-grey-bot"
      style="min-width: 100%;width: 100%;"
    >
      <div
        class="d-flex justify-space-between"
        :class="verticalClass(split)"
        v-for="split in splits"
        :key="split"
      >
        <div class="d-flex justify-start tabs">
          <v-tabs
            v-model="tabs[split]"
            align-with-title
            show-arrows
          >
            <v-tabs-slider color="primary" />
            <v-tab
              v-for="(item, index) in items"
              :key="index"
            >
              {{ $t('journal.sectionCreation.tabs.name', {index: index + 1}) }}
              <v-icon
                class="pa-1 ml-2"
                size="18px"
                @click.stop="onRemove(index)"
              >
                close
              </v-icon>
            </v-tab>
          </v-tabs>
          <v-tooltip
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <div class="d-flex align-center ml-2 mr-2">
                <v-icon
                  @click.stop="onAdd"
                  class="pa-1"
                  v-bind="attrs"
                  v-on="on"
                >
                  add
                </v-icon>
              </div>
            </template>
            <span>
              {{ $t('journal.sectionCreation.tabs.add') }}
            </span>
          </v-tooltip>
        </div>
        <div class="d-flex justify-start">
          <v-tooltip
            v-if="toggleVerticalSplitEnabled"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <div class="d-flex align-center mr-2">
                <v-icon
                  @click.stop="toggleVerticalSplit"
                  class="pa-1"
                  v-bind="attrs"
                  v-on="on"
                >
                  vertical_split
                </v-icon>
              </div>
            </template>
            <span>
              {{ $t('journal.sectionCreation.tabs.split') }}
            </span>
          </v-tooltip>
        </div>
      </div>
    </div>
    <div>
      <div
        class="d-flex justify-start"
      >
        <div
          v-for="split in splits"
          :key="split"
          :class="verticalClass(split)"
        >
          <v-tabs-items v-model="tabs[split]">
            <v-tab-item
              class="background-grey"
              v-for="(item, index) in items"
              :key="index"
            >
              <slot :item="item" :index="index" :split="split" />
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SplitTabs',
  props: {
    items: {
      type: Array,
      required: true,
    },
    toggleVerticalSplitEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tabs: [null, null],
    splits: [0],
  }),
  methods: {
    verticalClass(split) {
      const classes = [];
      if (split === 1) {
        classes.push('border-left');
      }
      if (this.splits.length === 2) {
        classes.push('split-vertical-tab');
      } else {
        classes.push('full-space');
      }
      return classes;
    },
    toggleVerticalSplit() {
      if (this.splits.length === 2) {
        this.splits = [0];
      } else {
        this.splits = [0, 1];
      }
    },
    onAdd(split) {
      this.$emit('add', split);
    },
    onRemove(index) {
      this.$emit('remove', index);
    },
  },
};
</script>
<style>
.border-grey {
  border: 1px solid #E0E0E0;
  border-radius: 5px;
}
.border-grey-bot {
  border-bottom: 1px solid #E0E0E0;
}
.split-vertical-tab {
  max-width: 50%;
  min-width: 50%;
  width: 50%;
}
.full-space {
  width: 100%;
}
.add-btn {
  width: 24px;
  height: 24px;
  border-radius: 12px;
  font-size: 18px;
}
.border-left {
  border-left: 1px solid #E0E0E0;
}
.tabs {
  max-width: calc(100% - 96px);
}
</style>
